"use client";

import PropTypes from "prop-types";
import React, { Children, useState } from "react";

export const Tabs = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="relative mx-auto">
      <nav aria-label="Tabs" className="c-tabs">
        {Children.toArray(children).map((child, index) => (
          <button
            key={index}
            className={`c-tabs__link ${
              activeTab === index
                ? "c-tabs__link--active font-medium"
                : "font-normal"
            }`}
            role="tab"
            aria-selected={activeTab === index}
            aria-controls={`tab-panel-${index}`}
            onClick={() => setActiveTab(index)}
            id={`tab-${index}`}
          >
            {child.props.label}
          </button>
        ))}
      </nav>

      <div className="pt-3">
        {Children.toArray(children).map((child, index) =>
          index === activeTab ? (
            <section
              key={index}
              role="tabpanel"
              id={`tab-panel-${index}`}
              aria-labelledby={`tab-${index}`}
            >
              {child}
            </section>
          ) : null
        )}
      </div>
    </div>
  );
};

export const TabsItem = ({ children }) => {
  return <div>{children}</div>;
};

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
};

TabsItem.propTypes = {
  children: PropTypes.node.isRequired,
};
